export default () => ({
  options : ['en', 'es', 'pt-BR'],
  current : 'pt-BR',
  default : null
});
